import PropTypes from 'prop-types'

import {
  getAttackStageReadable,
  isInHaltingStage
} from 'components/attacks/utils/attack-stages'
import { getResolvedHosts } from 'components/attacks/utils/attacks'
import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import { getFormattedAttackType } from 'utils/metadata'

import AttackRow, {
  AttackDescription,
  TargetsColumn,
  Status,
  HaltButton,
  DetailsChevron
} from './common/AttackRow'
import { IlfiTargets } from './common/Targets'

export default function IlfiAttackRow({
  attack,
  doFetch,
  clickableRow,
  selectableRow,
  onRowSelected,
  onHaltAttack,
  showHaltButton,
  checked
}) {
  const commandType =
    attack?.args[0] ?? attack?.infra_command?.commandArgs?.cliArgs[0]

  const { guid: attackId } = attack
  const resolvedHosts = getResolvedHosts(attack)
  const isHalting = isInHaltingStage(attack.stage)

  return (
    <AttackRow
      data-active-attack-row
      checked={checked}
      clickableRow={clickableRow}
      selectableRow={selectableRow}
      showHaltButton={showHaltButton}
      to={`/attacks/${attack.guid}`}
      onRowSelected={onRowSelected}
    >
      <AttackDescription
        description={
          isHalting ? (
            'Halting...'
          ) : (
            <Status>
              {getAttackStageReadable(attack.stage)}
              ...
            </Status>
          )
        }
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={commandType} />
          </GlyphIcon>
        }
        name={getFormattedAttackType(commandType)}
      />
      <TargetsColumn>
        <IlfiTargets targets={resolvedHosts} />
      </TargetsColumn>
      {showHaltButton && (
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={onHaltAttack}
        />
      )}
      {clickableRow && <DetailsChevron />}
    </AttackRow>
  )
}

IlfiAttackRow.propTypes = {
  attack: PropTypes.object,
  doFetch: PropTypes.func,
  onRowSelected: PropTypes.func,
  onHaltAttack: PropTypes.func,
  clickableRow: PropTypes.bool,
  selectableRow: PropTypes.bool,
  showHaltButton: PropTypes.bool,
  checked: PropTypes.bool
}
